import React from "react";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ListItemViewModel} from "../../../infrastructure/models/list-item.view-model";
import classnames from "classnames";
import {BoxScoresWidgetState} from "../models/box-scores-widget.state";
import {SecondaryTabs} from "../../../core/components/secondary-tabs/components/secondary-tabs";
import {observer} from "mobx-react";
import styles from "../styles/box-scores-widget.module.scss";
class BoxScoresWidgetTabsProps extends BaseProps {
  onTabChange: Function;
  state: BoxScoresWidgetState;
}

export const BoxScoresWidgetTabs = observer(({controller, onTabChange}: BoxScoresWidgetTabsProps) => {
  const {state} = controller;
  const {tabs, selectedTab} = state;
  const tabsProps = {
    onChange: (e, tab: ListItemViewModel) => onTabChange && onTabChange(e, tab),
    initialIndex: selectedTab,
    tabs
  }

  const containerProps = {
    className: classnames(styles.tabs_container)
  }

  return (<div {...containerProps}>
    <SecondaryTabs {...tabsProps}/>
  </div>)
});
